import { createTheme } from '@mantine/core';
import { semanticColors } from '../tokens/colors';
import { radius } from '../tokens/radius';
import { shadows } from '../tokens/shadows';
import { fontWeights } from '../tokens/typography';
import { defaultDensity, densityTokens } from '../tokens/density';

const density = densityTokens[defaultDensity];

export const appTheme = createTheme({
  fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontSizes: {
    xs: '11px',
    sm: '13px',
    md: '14px',
    lg: '16px',
    xl: '18px',
  },
  headings: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: String(fontWeights.bold),
    sizes: {
      h1: { fontSize: '28px', lineHeight: '36px' },
      h2: { fontSize: '20px', lineHeight: '28px' },
      h3: { fontSize: '16px', lineHeight: '24px' },
    },
  },
  primaryColor: 'blue',
  colors: {
    brand: [
      '#eef4ff',
      '#dce8ff',
      '#b9d0ff',
      '#8fb2ff',
      '#5f8eff',
      '#326af0',
      '#2454c7',
      '#1d439f',
      '#18377f',
      '#132c66',
    ],
    navy: [
      '#f3f6fb',
      '#dfe7f3',
      '#b8c6da',
      '#8b9db8',
      '#5f718c',
      '#3d4d64',
      '#273449',
      '#182236',
      '#101827',
      '#080f1f',
    ],
    success: [
      '#e9fbf0',
      '#d5f6e1',
      '#a8ebc2',
      '#76dfa0',
      '#43cd7a',
      '#21b45d',
      '#158f49',
      '#0d6f39',
      '#095a2f',
      '#064825',
    ],
    warning: [
      '#fff8e5',
      '#ffefbd',
      '#ffe08a',
      '#ffce4f',
      '#f5ad12',
      '#d98f00',
      '#ad7100',
      '#875800',
      '#6d4700',
      '#573800',
    ],
    danger: [
      '#fff0f1',
      '#ffdadd',
      '#ffb4bb',
      '#ff8792',
      '#fb5b6b',
      '#e93449',
      '#c51f33',
      '#9e1829',
      '#7e1422',
      '#66111c',
    ],
  },
  radius: {
    xs: '6px',
    sm: radius.control,
    md: radius.panel,
    lg: radius.dialog,
    xl: '22px',
  },
  shadows: {
    xs: shadows.surface,
    sm: shadows.floating,
    md: shadows.dialog,
    lg: '0 20px 60px rgba(15, 23, 42, 0.12)',
  },
  defaultRadius: 'md',
  other: {
    semanticColors,
    density,
  },
  components: {
    Button: {
      defaultProps: {
        size: 'sm',
      },
    },
    TextInput: {
      defaultProps: {
        size: 'sm',
      },
    },
    NativeSelect: {
      defaultProps: {
        size: 'sm',
      },
    },
    Table: {
      defaultProps: {
        verticalSpacing: density.verticalSpacing,
        horizontalSpacing: 'sm',
        highlightOnHover: true,
      },
    },
    Card: {
      defaultProps: {
        withBorder: true,
        shadow: 'xs',
        radius: 'md',
        padding: 'lg',
      },
    },
    Modal: {
      defaultProps: {
        radius: 'lg',
        centered: true,
      },
    },
    Badge: {
      defaultProps: {
        radius: 'xl',
        size: 'sm',
        variant: 'light',
      },
    },
  },
});
